import React from 'react';
import ServiceDetail from '@/components/services/ServiceDetail';

export default function EmergencyGarageDoorRepair() {
  return <ServiceDetail serviceKey="emergency" />;
}